export default __webpack_public_path__ + "static/media/explore_image.a696f62b.svg";